import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
// elementUI
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);
// router
import router from "./router";
// axios
import axios from "@assets/js/axios";
Vue.use(axios);
// store
import store from '@store';
// 工具函数
import $tool from '@assets/js/tool';
Vue.prototype = Object.assign(Vue.prototype, $tool);
// 校验函数
import strategy from "@assets/js/strategy";
Vue.use(strategy);
// 通用图片前缀
Vue.prototype.imgUrl = "http://oa.cstravel.cn";

import VueCropper from 'vue-cropper'
Vue.use(VueCropper)

import $user from './api/user';

Vue.prototype.setCookie = function (cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires=" + d.toUTCString();
  // console.info(cname + "=" + cvalue + "; " + expires);
  document.cookie = cname + "=" + cvalue + "; ";
  // console.info(document.cookie);
},
  //获取cookie
  Vue.prototype.getCookie = function (cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    // console.log("获取cookie,现在循环")
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      // console.log(c)
      while (c.charAt(0) == ' ') c = c.substring(1);
      if (c.indexOf(name) != -1) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  },
  //清除cookie
  Vue.prototype.clearCookie = function () {
    console.log('清除cookie')
    this.setCookie("checked", "", -1);
  },
  Vue.prototype.checkCookie = function () {
    var user = this.getCookie("username");
    if (user != "") {
      alert("Welcome again " + user);
    } else {
      user = prompt("Please enter your name:", "");
      if (user != "" && user != null) {
        this.setCookie("username", user, 365);
      }
    }
  }



// 公共函数
Vue.prototype.test = async function () {
  // console.log('全局函数');
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  // 没有用户登录信息，删cook
  if (userInfo === null || "token" in userInfo === false) {
    // console.log('没有用户登录信息，删cook')
    this.clearCookie();
  }
  // 有用户信息，先判断有没有cook，若果有，over；若没有，判断是否过期；
  else {
    let cook = this.getCookie('checked')
    // console.log('cook=====' + cook)
    if (cook == 1) {
      // console.log('有用户登录信息，cook=1')
    } else {
      // console.log('有用户登录信息，无cook')
      const res = await $user.checkLogin();
      // console.log(res)
      // 过期，删userInfo
      if ("success" in res === false) {
        // this.clearUserInfo();
        localStorage.removeItem('userInfo');
        // console.log('token过期，删userInfo')
      }
      // 没有过期，加cook
      else {
        // console.log('token没有过期，加cook')
        this.updateUserInfo(res);
        this.setCookie('checked', '1', '')
      }
    }
  }
}


// (function () {
//   console.log('全局函数');
//   const userInfo = JSON.parse(localStorage.getItem("userInfo"));
//   // 没有用户登录信息，删cook
//   if (userInfo === null || "token" in userInfo === false) {
//     console.log('没有用户登录信息，删cook')

//     // 判断有没有cook，
//     var name = "checked=";
//     var ca = document.cookie.split(';');
//     console.log("获取cookie,现在循环")
//     for (var i = 0; i < ca.length; i++) {
//       var c = ca[i];
//       // console.log(c)
//       while (c.charAt(0) == ' ') c = c.substring(1);
//       if (c.indexOf(name) != -1) {
//         var cook = c.substring(name.length, c.length)
//         // return c.substring(name.length, c.length);
//       }
//     }
//     // let cook = this.getCookie('checked')
//     console.log('cook=====' + cook)
//     // 有cook=1，删，没有，返回
//     if (cook == 1) {
//       var d = new Date();
//       d.setTime(d.getTime() + (-1 * 24 * 60 * 60 * 1000));
//       var expires = "expires=" + d.toUTCString();
//       console.info("checked" + "=" + '' + "; " + expires);
//       document.cookie = "checked" + "=" + '' + "; ";
//     } else {
//       console.log('没有cook=1')
//       // console.info(document.cookie);
//       // this.setCookie("checked", "", -1);
//     }
//   }
//   // 有用户信息，先判断有没有cook，若果有，over；若没有，判断是否过期；
//   else {
//     // 判断有没有cook，
//     var name = "checked=";
//     var ca = document.cookie.split(';');
//     console.log("获取cookie,现在循环")
//     for (var i = 0; i < ca.length; i++) {
//       var c = ca[i];
//       // console.log(c)
//       while (c.charAt(0) == ' ') c = c.substring(1);
//       if (c.indexOf(name) != -1) {
//         var cook = c.substring(name.length, c.length)
//         // return c.substring(name.length, c.length);
//       }
//     }
//     // let cook = this.getCookie('checked')
//     console.log('cook=====' + cook)
//     if (cook == 1) {
//       console.log('有用户登录信息，cook=1')
//     } else {
//       console.log('有用户登录信息，无cook')
//       const res = $user.checkLogin()
//       console.log(res)
//       // 过期，删userInfo
//       if ("error" in res === true) {
//         // this.clearUserInfo();
//         localStorage.removeItem('userInfo');
//         console.log('token过期，删userInfo')
//       }
//       // 没有过期，加cook
//       else {
//         console.log('token没有过期，加cook')
//         // this.setCookie('checked', '1', '')
//         var d = new Date();
//         d.setTime(d.getTime() + (-1 * 24 * 60 * 60 * 1000));
//         var expires = "expires=" + d.toUTCString();
//         console.info("checked" + "=" + '1' + "; " + expires);
//         document.cookie = "checked" + "=" + '1' + "; ";
//       }
//     }

//   }
// }())


import '@assets/style/main.css';
import App from './App.vue';

Vue.config.productionTip = false;


const vm = new Vue({
  router,
  store,
  // test,
  render: (h) => h(App),
}).$mount("#app");

export default vm;